import styled from "styled-components";
import { BordererCardProps } from "./BordererCard";
import { getSizeInRem } from "../../../methods/common";
import COLORS from "../../../constants/colors";

export const StyledBorderedCard = styled.div<Partial<BordererCardProps>>`
    padding: ${({ padded = true }) => (padded ? "1rem" : undefined)};
    border-radius: ${({ borderRadius = "8px" }) => borderRadius};
    border: 1px solid ${({ borderColor = COLORS.GREY_200 }) => borderColor};
    background-color: ${({ backgroundColor = "white" }) => backgroundColor};
    box-shadow: 0px 0px 24px -4px rgba(16, 24, 40, 0.1);
    width: ${(props) => getSizeInRem(props.width)};
    overflow: ${({ overflow = "hidden" }) => overflow};
`;
